let _ = t => t,
  _t,
  _t2,
  _t3;
import styled from 'styled-components';
import { colors, styledIf } from '@ovpn-ui/styles';
import { shadows } from '../styles';
export const Card = styled.div(_t || (_t = _`
    position: relative;

    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: flex-start;

    max-width: 343px;

    padding: 24px;

    overflow: hidden;

    background-color: ${0};

    border: 1px solid ${0};
    border-radius: 8px;

    box-shadow: ${0};

    pointer-events: auto;

    ${0}
`), colors.neutralWhite, colors.neutralLight, shadows.sm, styledIf('$interactive')(_t2 || (_t2 = _`
        &:hover {
            background-color: ${0};
        }

        &:focus,
        &:focus-within {
            background-color: ${0};

            box-shadow: ${0};
        }

        ${0}
    `), colors.neutralOffwhite, colors.neutralOffwhite, shadows.focusedBlue, styledIf('$disabled')(_t3 || (_t3 = _`

            pointer-events: none;

            &:after {
                position: absolute;
                top: 0;
                right: 0;

                z-index: 2;

                width: 100%;
                height: 100%;

                background-color: ${0};

                opacity: 0.5;

                content: '';
            }
        `), colors.neutralBg)));